<!--
@component
Inline text link; `external` adds an icon, `primary` uses the accent color.

@use-instead-of raw <a> with link classes
-->
<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    href: string;
    primary?: boolean;
    newTab?: boolean;
    external?: boolean;
    onclick?: () => void;
    children: Snippet;
  }

  let {
    href,
    primary = false,
    newTab = false,
    external = false,
    onclick,
    children,
  }: Props = $props();

  let relValues: string[] = [];
  $effect(() => {
    if (newTab && external) {
      relValues.push("noreferrer");
    }
    if (external) {
      relValues.push("external");
    }
  });
</script>

<a
  class={primary ? "primary-link" : "secondary-link"}
  {href}
  rel={relValues.length > 0 ? relValues.join(" ") : undefined}
  target={newTab ? "_blank" : undefined}
  {onclick}
>
  {@render children()}
</a>

<style lang="postcss">
  @reference "$app.css";

  .primary-link {
    @apply font-medium text-accent;
  }

  .primary-link:hover {
    @apply underline;
  }

  .secondary-link {
    @apply text-secondary underline decoration-1 underline-offset-1;
  }
</style>
